<template>
	<v-row class='fill-height' align="end">
		<v-col cols='4'>
			<v-row>
				<v-col cols='12'>
					<v-row justify='center' no-gutters>
						<v-col cols='auto'>
							<h1 class='white--text'>DRAWINGS</h1>
						</v-col>
					</v-row>
					<v-row justify='center' no-gutters>
						<v-col v-for='sortition in generalInformation.sortedSortitions' cols='auto' :key='sortition.id'>
							<span
								class="font-weight-bold text-h5 mx-2"
								:class='{"red--text": generalInformation.sortition.id === sortition.id, "white--text": generalInformation.sortition.id !== sortition.id }'>
								{{ sortition.abbreviation }}
							</span>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols='12' v-for='(result) in generalInformation.results.slice(1, 4)' :key='result.sortition.id'>
					<v-card class='white--text text-center fill-height rounded-xl'>
						<result-horizontal-display
							:pick-three-image="{ src: require('@/assets/img/paradiseLottery/pick3.webp'), width: '100px', height: '45px', contain: true, class: 'mx-1' }"
							:pick-four-image="{ src: require('@/assets/img/paradiseLottery/pick4.webp'), width: '100px', height: '50px', contain: true, class: 'mx-1' }"
							:result='result'
						>
							<template #name="{sortition}">
								<h3 class="font-weight-bold text-uppercase text-wrap">{{ sortition.name }}</h3>
							</template>
						</result-horizontal-display>
					</v-card>
				</v-col>
			</v-row>
		</v-col>

		<v-col cols='4' class="px-0">
			<v-row no-gutters>
				<v-col class='justify-center'>
					<v-img class='mx-auto' contain width='180' :src="require('@/assets/img/paradiseLottery/logo.png')"/>
				</v-col>
			</v-row>
			<v-row justify="center" no-gutters>
				<v-col cols="8">
					<v-card class='white--text rounded-xl'>
						<countdown
							id="upcoming-result"
							class="text-center mt-5"
							:sortition="generalInformation.sortition">
							<template #default='{sortition}'>
								<v-flex md3>
									<h1 class='font-weight-bold text-uppercase'>Next draw in</h1>
								</v-flex>
								<v-flex md3>
									<span id='time-left' v-if='sortition.timeLeft'
												class='font-weight-black text-uppercase'>{{ sortition.timeLeft }}</span>
									<span v-else><font-awesome-icon icon='sync' spin size='3x'></font-awesome-icon></span>
								</v-flex>
							</template>
						</countdown>
					</v-card>
				</v-col>
			</v-row>
			<v-row justify="center" no-gutters class="pt-5 pb-2">
				<v-col cols="10">
					<v-card id="last-winning-card" class='white--text text-center fill-height rounded-xl'>
						<div class='font-weight-bold ma-3 text-uppercase text-center text-h5 white--text'>LAST WINNNING NUMBERS</div>
						<result-display v-if='generalInformation.results[0]'
														class="pa-0 mb-3"
														:image-dimensions="{ height: '55px', width: '55px' }"
														:pick-three-image="{ src: require('@/assets/img/paradiseLottery/pick3.webp'), width: '120px', height: '50px',contain: true }"
														:pick-four-image="{ src: require('@/assets/img/paradiseLottery/pick4.webp'), width: '120px', height: '50px', contain: true }"
														:result='generalInformation.results[0]'>
							<template #first-second-third-header>
								<div class="col-12">
									<hr class="my-3"/>
								</div>
							</template>
							<template #name="{sortition}">
								<h3 class="font-weight-bold text-uppercase text-wrap">{{ sortition.name }}</h3>
							</template>
						</result-display>
					</v-card>
				</v-col>
			</v-row>
		</v-col>

		<v-col cols='4'>
			<v-row align="end" no-gutters class='fill-height'>
				<v-col cols='12' class='text-center'>
					<div id='current-time' class='white--text'>
						<font-awesome-icon icon='clock'></font-awesome-icon>
						<current-time-display :general-information='generalInformation'/>
					</div>
				</v-col>
				<v-col cols='12'>
					<v-card class='w-100 white--text prizes-card align-center d-flex h-100' rounded='xl'>
						<v-row no-gutters>
							<v-col cols='12'>
								<span class='prizes-title'>Prizes</span>
								<prizes-list class='font-weight-bold' :general-information='generalInformation'>
									<template #prize-row='{prize}'>
										<v-col class='prize-name' cols='6'>
											{{ prize.name }}
										</v-col>
										<v-col class='prize-amount' cols='6'>
											{{ prize.amount }}
										</v-col>
									</template>
								</prizes-list>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</v-col>

	</v-row>
</template>

<script>
import Countdown from '@homepage/components/Countdown.vue';
import {generateImageMapFor} from '@homepage/helpers/image.js';
import PrizesList from '@homepage/components/PrizesList.vue';
import CurrentTimeDisplay from '@homepage/components/CurrentTimeDisplay.vue';
import ResultHorizontalDisplay from "@homepage/components/ResultHorizontalDisplay.vue";
import ResultDisplay from "@homepage/components/ResultDisplay.vue";

export default {
	name: 'ParadiseLotteryBoard',
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
			generalInformation: this.generalInformation
		};
	},
	props: {
		generalInformation: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			timeToShowResultsPage: 30000,
			timeToShowPrizesPage: 1000,
			timeToShowEachLotteryResultPage: 10000,
			lotteryEntriesPerPage: 2
		};
	},
	components: {
		ResultDisplay,
		CurrentTimeDisplay,
		ResultHorizontalDisplay,
		PrizesList,
		Countdown
	},
	beforeCreate() {
		this.$emit('change-style', {backgroundImage: require('@/assets/img/paradiseLottery/background-dark.webp')});
	}
};
</script>
<style scoped>
.theme--light.v-card {
	border: 4px solid white;
	background-color: rgba(87, 220, 194, 45%);
	backdrop-filter: blur(5px);
}

.prizes-title {
	font-size: 300%;
	font-weight: bold;
}

.prize-name {
	font-size: 180%;
}

.prize-amount {
	font-size: 240%;
	font-weight: 800;
}

.prizes-card {
	text-align: center;
}

#current-time {
	font-size: 250%;
	font-weight: bold;
}

::v-deep .prize-item:nth-child(odd) {
	background-color: #5563a54f;
}

#time-left {
	font-weight: bold;
	font-size: 3.5rem;
	text-align: center;
	color: white;
}

@keyframes blink {
	from {
		border: 3px solid #e5454f;
		box-shadow: 0 0 25px black;
	}
	to {
		box-shadow: 0 0 25px #818181;
		border: 3px solid #1fbdc3;
	}
}

#last-winning-card {
	transition: border, box-shadow;
	animation: blink 1s infinite alternate ease;
}
</style>

<style>
.lottery-result:nth-child(even) {
	background-color: #eaeaea;
}
</style>
